(() => {
  if (window.cozyCountdownLoaded) return;
  window.cozyCountdownLoaded = true;
  const KEY = 'cozyhaven.display-countdown.v1';
  const HOUR = 3600000;
  const DAY = 24 * HOUR;
  const banners = new Map();
  const editorPreview = Boolean(window.Shopify && window.Shopify.designMode);
  let deadline;
  function valid(value) {
    return value && value.version === 1 && Number.isFinite(value.deadline) && value.deadline > 0;
  }
  function save() {
    if (editorPreview) return;
    try { localStorage.setItem(KEY, JSON.stringify({ version: 1, deadline })); } catch (_) { /* Browser storage may be disabled. Keep this page's countdown. */ }
  }
  function load(banner) {
    try {
      const stored = editorPreview ? null : JSON.parse(localStorage.getItem(KEY));
      if (valid(stored)) { deadline = stored.deadline; return; }
    } catch (_) { /* Invalid or unavailable storage starts a new local countdown. */ }
    function hours(value, fallback) {
      const number = Number(value);
      return Number.isFinite(number) && number >= 1 && Number.isSafeInteger(Math.floor(number) * 3600) ? Math.floor(number) : fallback;
    }
    const first = hours(banner?.dataset.initialMinHours, 10);
    const second = hours(banner?.dataset.initialMaxHours, 22);
    const min = Math.min(first, second) * 3600;
    const max = Math.max(first, second) * 3600;
    deadline = Date.now() + (min + Math.floor(Math.random() * (max - min + 1))) * 1000;
    save();
  }
  function tick() {
    const now = Date.now();
    if (now >= deadline) {
      deadline += (Math.floor((now - deadline) / DAY) + 1) * DAY;
      save();
    }
    const total = Math.max(0, Math.ceil((deadline - now) / 1000));
    for (const [banner, units] of banners) {
      if (!banner.isConnected) { banners.delete(banner); continue; }
      const days = units.days && total > 86400 ? Math.floor(total / 86400) : 0;
      const values = { days, hours: Math.floor(total / 3600) - days * 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
      for (const [key, element] of Object.entries(units)) {
        const value = String(values[key]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      }
      banner.hidden = false;
    }
  }
  function initialize(root) {
    let firstBanner;
    root.querySelectorAll('[data-cozy-countdown]').forEach(banner => {
      if (!firstBanner) firstBanner = banner;
      if (!banners.has(banner)) banners.set(banner, Object.fromEntries([...banner.querySelectorAll('[data-time]')].map(el => [el.dataset.time, el])));
    });
    if (deadline === undefined || (editorPreview && firstBanner)) load(firstBanner);
    tick();
  }
  initialize(document);
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  window.addEventListener('pageshow', tick);
  window.addEventListener('storage', event => {
    if (event.key !== KEY) return;
    try {
      const stored = JSON.parse(event.newValue);
      if (valid(stored)) { deadline = stored.deadline; tick(); }
    } catch (_) { /* Ignore unrelated malformed storage values. */ }
  });
})();
